import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { BlogTags } from '@app/_shared/_enums/blog-tags';
import { SEO, IShopifyProduct } from '@app/_shared/_models';
import { BlogService, ProductService, SeoService } from '@app/_shared/_services';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IBlogPost } from '../_prismic/blog-post';
import { ImageComponent } from '../../_shared/_components/image/image.component';
import { ProductCardComponent } from '../../_shared/_components/product-card/product-card.component';
import { RouterLink } from '@angular/router';
import { AsyncPipe, UpperCasePipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-cold-plunge-with-sirona-spa-care',
    templateUrl: './cold-plunge-with-sirona-spa-care.component.html',
    styleUrls: ['./cold-plunge-with-sirona-spa-care.component.scss'],
    imports: [NgxSpinnerComponent, ImageComponent, ProductCardComponent, RouterLink, AsyncPipe, UpperCasePipe, DatePipe]
})
export class ColdPlungeWithSironaSpaCareComponent implements OnInit, OnDestroy {
  private readonly blogService = inject(BlogService);
  private readonly ngxSpinnerService = inject(NgxSpinnerService);
  private readonly productService = inject(ProductService);
  private readonly seoService = inject(SeoService);

  public seo: SEO = {
    image: 'https://mypoolhut.com/assets/images/cold-plunge-sirona-spa-care.jpg',
    metaDescription: `Learn the maintain program for your cold plunge using Sirona Spa Care products sold at My Pool Hut!`,
    metaTitle: `How to Properly Maintain Your Cold Plunge with Sirona Spa Care Products`
  };
  public spinner$: Observable<NgxSpinner>;
  public product$: Observable<IShopifyProduct | undefined>;
  public blogPost!: IBlogPost;
  public sanitizer: IShopifyProduct | undefined;
  public oxidizer: IShopifyProduct | undefined;
  public testStrips: IShopifyProduct | undefined;
  public spaDown: IShopifyProduct | undefined;
  public spaUp: IShopifyProduct | undefined;
  private readonly blogTags = BlogTags;
  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  constructor() {
    const ngxSpinnerService = this.ngxSpinnerService;

    this.spinner$ = ngxSpinnerService.spinnerObservable;
    this.product$ = this.productService.product$;
  }

  public async ngOnInit(): Promise<void> {
    this.seoService.setMetaData(this.seo);
    this.seoService.createCanonicalUrl('https://mypoolhut.com/blog/cold-plunge-with-sirona-spa-care');

    await this.ngxSpinnerService.show();
    this.blogService.blogs$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async (blogs: Array<IBlogPost>) => {
        const index = blogs.findIndex(b => b.tag === this.blogTags.COLD_PLUNGE_WITH_SIRONA_SPA_CARE);
        if (index > -1) {
          this.blogPost = blogs[index];
          await this.ngxSpinnerService.hide();
        } else {
          await this.blogService.loadBlogs();
        }
      });

    this.sanitizer = await this.productService.loadProductByHandle('sirona-spa-care-simply-sanitizer');
    this.oxidizer = await this.productService.loadProductByHandle('sirona-spa-care-simply-oxidizer');
    this.testStrips = await this.productService.loadProductByHandle('sirona-spa-care-simply-test-strips');
    this.spaDown = await this.productService.loadProductByHandle('sirona-spa-care-spa-down');
    this.spaUp = await this.productService.loadProductByHandle('sirona-spa-care-spa-up');
  }

  public ngOnDestroy(): void {
    this.seoService.removeCanonicalUrl();
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
